<script setup>
import FooterBlank from "@/layouts/components/FooterBlank.vue"
import { router } from "@/plugins/1.router"
import { dataCondition } from "@/utils/content"
definePage({
  meta: {
    layout: "blank",
    public: true,
  },
})
const CURRENT_YEAR = import.meta.env.VITE_CURRENT_YEAR

function redirectHome() {
  router.push({ name: "index" })
}
</script>

<template>
  <div class="register">
    <div class="register__banner">
      <div class="register__banner-title">
        <img
          src="@/assets/logo.png"
          width="148"
          height="84"
          loading="lazy"
          alt="logo"
          cover
          class="pointer"
          @click="redirectHome()"
        />
        <h1>{{ $gettext("Enquêtes France") }} {{ CURRENT_YEAR }}</h1>
      </div>
    </div>

    <div class="layout-legal">
      <VCard>
        <VCardText>
          <h2 class="text-bree">
            {{ $gettext("CONDITIONS GÉNÉRALES D'UTILISATION") }}
          </h2>
        </VCardText>
        <VCardText>
          <CollapseInfomation
            :data="dataCondition"
            :uppercase="true"
            :infomation="true"
          />
        </VCardText>
      </VCard>
    </div>

    <FooterBlank />
  </div>
</template>

<style lang="scss">
@import "@/assets/styles/pages/register.scss";
.register {
  display: flex;
  flex-direction: column;
}
.layout-legal {
  max-width: 70%;
  margin: auto;
  margin-top: -72px;

  h2 {
    text-align: center;
    color: rgba(var(--v-theme-second-primary));
    font-weight: 500;
  }
}
.footer-blank {
  padding: 0 !important;
  align-content: end;

  &__container {
    margin-top: 30px !important;
    position: unset !important;
    bottom: unset !important;
    left: unset !important;
    transform: unset !important;
  }
}
</style>
